import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import ResearchCitizenshipNotificationsShared from '../../research-notifications/research-citizenship';
import { BreadcrumbItem } from '../../breadcrumb';

interface ResearchCitizenshipAnscNotificationsSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const ResearchCitizenshipAnscNotificationsShared = ({
  scope,
  items,
}: ResearchCitizenshipAnscNotificationsSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/cittadinanza/ricerca/registrazione`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <ResearchCitizenshipNotificationsShared
        redirectUrl={redirectUrl}
        goBackUrl={goBackUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchCitizenshipAnscNotificationsShared.displayName =
  'Research Citizenship Notifications Page component';

export default ResearchCitizenshipAnscNotificationsShared;
